import { DateTime } from 'luxon';
import type { FC } from 'react';

interface Props {
  date?: Date;
}

export const DateFormat: FC<Props> = ({ date }) => (
  <span>
    {date
      ? DateTime.fromJSDate(date).toLocaleString(DateTime.DATE_MED_WITH_WEEKDAY)
      : '-'}
  </span>
);

export const DateTimeFormat: FC<Props> = ({ date }) => (
  <span>
    {date
      ? DateTime.fromJSDate(date).toLocaleString(
          DateTime.DATETIME_MED_WITH_WEEKDAY,
        )
      : '-'}
  </span>
);
